import React, { useState, useContext, useMemo, useRef, useEffect } from "react";
import { Route, Routes, Link, Navigate } from "react-router-dom";
import Home from "./components/Home";
import Results from "./components/Results";
import Services from "./components/Services";
import Contact from "./components/Contact";
import MyAccount from "./components/MyAccount";
import { BetHistory } from "./components/BetHistory";
import Deposit from "./components/Deposit";
import Register from "./components/Register";
import "./App.css";
import exampleImage from "./Images/Huntex.jpg";
import UserProfile from "./components/UserProfile";
import { FaCaretDown, FaCaretUp, FaBars, FaTimes } from "react-icons/fa";
import { AuthContext } from "./context/AuthContext";
import { Withdrawal } from "./components/Withdrawal";
import { LotteryResults } from "./components/LotteryResults";
import MobileLogin from "./components/MobileLogin";
import ArkeselLogin from "./components/ArkeselLogin";
import Faqs from "./components/Faqs";
import Privacy from "./components/Privacy";
import { UserReceipt } from "./components/UserReceipt";
import LoginScreen from "./components/LoginScreen";
import PostResultScreen from "./components/PostResultScreen";
import UserPayment from "./components/UserPayment";
import AdminTransactions from "./components/AdminTransactions";
import HighWinners from "./components/HighWinners";
import HubtelReceive from "./components/HubtelReceive";
import PaymentPage from "./components/PaymentPage";
import VerifyScreen from "./components/VerifyScreen";
import PasswordResetStep1 from "./components/PasswordResetStep1";
import ResetPasswordScreen from "./components/ResetPasswordScreen";
import SendexaPasswordReset from "./components/SendexaPasswordReset";
import SendexaResetVerify from "./components/SendexaResetVerify";
import InstallPWA from "./components/InstallPWA";
import ShortId from "./components/ShortId";
import Chat from "./components/Chat";
import AllGames from "./components/AllGames";
import UserChat from "./components/UserChat";
import WinAbove from "./components/WinAbove";
import Forcasters from "./components/Forcasters";
import "./styles/Home.css";

/*
const REFERRAL_BANNER_KEY = "huntex_referral_banner_seen";
const REFERRAL_BANNER_MAX_PER_DAY = 3;
*/
const WINNERS_SHOWN_IDS_KEY = "huntex_winners_shown_ids";

const getGameWinId = (game) => String(game?.id ?? game?._id ?? "").trim();

const App = () => {
  const {
    password,
    setPassword,
    phoneNumber,
    setPhoneNumber,
    handleLogin,
    handleLogout,
    isLoggedIn,
    token,
    userData,
    setUserData,
    userBalance,
    setUserBalance,
    setWinBalance,
    role,
  } = useContext(AuthContext);

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  /* const [showReferralBanner, setShowReferralBanner] = useState(false); */
  const [showWinnersBanner, setShowWinnersBanner] = useState(false);
  const [totalWinnings, setTotalWinnings] = useState(0);
  const [currentBannerWinIds, setCurrentBannerWinIds] = useState([]);
  const navRef = useRef(null);
  const isAdminLike = role === "admin" || role === "superadmin";

  /*
  useEffect(() => {
    if (!isLoggedIn || isAdminLike) {
      setShowReferralBanner(false);
      return;
    }

    const today = new Date().toISOString().slice(0, 10);
    const raw = localStorage.getItem(REFERRAL_BANNER_KEY);

    let seenCountToday = 0;
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (parsed?.date === today) {
          const parsedCount = Number(parsed?.count);
          seenCountToday = Number.isFinite(parsedCount) ? parsedCount : 0;
        }
      } catch (error) {
        if (raw === today) {
          seenCountToday = 1;
        }
      }
    }

    if (seenCountToday < REFERRAL_BANNER_MAX_PER_DAY) {
      setShowReferralBanner(true);
    } else {
      setShowReferralBanner(false);
    }
  }, [isLoggedIn, isAdminLike]);
  */

  // Winners banner logic
  useEffect(() => {
    if (!isLoggedIn || isAdminLike || !userData?.savedNumbers) {
      setShowWinnersBanner(false);
      setCurrentBannerWinIds([]);
      return;
    }

    // Get list of already shown win IDs
    const shownIdsRaw = localStorage.getItem(WINNERS_SHOWN_IDS_KEY);
    let shownIds = [];
    try {
      const parsed = shownIdsRaw ? JSON.parse(shownIdsRaw) : [];
      shownIds = Array.isArray(parsed) ? parsed.map((id) => String(id)) : [];
    } catch (error) {
      shownIds = [];
    }
    const shownSet = new Set(shownIds);

    // Find won games that haven't been shown yet
    const wonGames = userData.savedNumbers.filter(
      (game) => game.outcome === "Won" && getGameWinId(game)
    );
    const newWins = wonGames.filter((game) => !shownSet.has(getGameWinId(game)));

    if (newWins.length === 0) {
      setShowWinnersBanner(false);
      setCurrentBannerWinIds([]);
      return;
    }

    // Calculate total from new wins
    const total = newWins.reduce((sum, game) => sum + (Number(game.winPrice) || 0), 0);
    if (total > 0) {
      setTotalWinnings(total);
      setCurrentBannerWinIds(newWins.map((game) => getGameWinId(game)));
      setShowWinnersBanner(true);
    } else {
      setShowWinnersBanner(false);
      setCurrentBannerWinIds([]);
    }
  }, [isLoggedIn, isAdminLike, userData]);

  /*
  const dismissReferralBanner = () => {
    const today = new Date().toISOString().slice(0, 10);
    const raw = localStorage.getItem(REFERRAL_BANNER_KEY);

    let currentCount = 0;
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (parsed?.date === today) {
          const parsedCount = Number(parsed?.count);
          currentCount = Number.isFinite(parsedCount) ? parsedCount : 0;
        }
      } catch (error) {
        if (raw === today) {
          currentCount = 1;
        }
      }
    }

    const nextCount = Math.min(currentCount + 1, REFERRAL_BANNER_MAX_PER_DAY);
    localStorage.setItem(
      REFERRAL_BANNER_KEY,
      JSON.stringify({ date: today, count: nextCount })
    );
    setShowReferralBanner(false);
  };
  */

  const dismissWinnersBanner = () => {
    // Add current shown wins to localStorage
    const shownIdsRaw = localStorage.getItem(WINNERS_SHOWN_IDS_KEY);
    let shownIds = [];
    try {
      const parsed = shownIdsRaw ? JSON.parse(shownIdsRaw) : [];
      shownIds = Array.isArray(parsed) ? parsed.map((id) => String(id)) : [];
    } catch (error) {
      shownIds = [];
    }

    const updatedIds = [...new Set([...shownIds, ...currentBannerWinIds])];
    localStorage.setItem(WINNERS_SHOWN_IDS_KEY, JSON.stringify(updatedIds));
    setCurrentBannerWinIds([]);
    setShowWinnersBanner(false);
  };

  const { isPWA, isWebView } = useMemo(() => {
    if (typeof window === "undefined") return { isPWA: false, isWebView: false };
    const isStandalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    const isNavigatorStandalone = window.navigator.standalone === true;
    const isPWA = !!(isStandalone || isNavigatorStandalone);
    const ua = navigator.userAgent || "";
    const isAndroidWebView = /\bwv\b/.test(ua) || (/Android/.test(ua) && /Version\/\d+\./.test(ua));
    const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.test(ua);
    const isReactNativeWebView = !!window.ReactNativeWebView;
    const isWebView = isReactNativeWebView || isAndroidWebView || isIOSWebView;
    return { isPWA, isWebView };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (menuOpen) {
      setDropdownOpen(false);
    }
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        closeMenu();
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
      <div className={`App ${isPWA ? 'pwa-mode' : ''} ${isWebView ? 'webview-mode' : ''}`}>
        <nav className="navbar" ref={navRef}>
          {isPWA && (<div className="menu-icon" onClick={toggleMenu}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>)}
          <div className="logo">
            {!isPWA && (
              <img
                src={exampleImage}
                alt="Huntex Logo"
                className="example-image"
              />
            )}
            <Link to="/" className="huntex-link">
              HUNTEXLOTTO
            </Link>
            {isLoggedIn && isPWA && (
              <UserProfile
                token={token}
                userData={userData}
                setUserData={setUserData}
                userBalance={userBalance}
                setUserBalance={setUserBalance}
                setWinBalance={setWinBalance}
              />
            )}
          </div>
          {!isPWA && (
          <div className="menu-icon" onClick={toggleMenu}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>)}
          <div className={`nav-links ${menuOpen ? "open" : ""}`}>
            <ul>
              <li>
                <Link to="/" onClick={closeMenu}>
                  Home
                </Link>
              </li>
              
              <li>
                <Link to="/LotteryResults" onClick={closeMenu}>
                  Results
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={closeMenu}>
                  Winners
                </Link>
              </li>
             {/* <li>
                <Link to="/forcasters" onClick={closeMenu}>
                  Forcasters
                </Link>
              </li>*/}
              
              <li>
                <Link to="/contact" onClick={closeMenu}>
                  Contact
                </Link>
              </li>
              {isLoggedIn && (
                <li className={`dropdown ${dropdownOpen ? "active" : ""}`}>
                  <span className="register-link" onClick={toggleDropdown}>
                    {isAdminLike ? (role === "superadmin" ? "Super Admin Panel" : "Admin Panel") : "My Account"} {dropdownOpen ? <FaCaretUp className="dropdown-arrow" /> : <FaCaretDown className="dropdown-arrow" />}
                  </span>
                  <div className="dropdown-content">
                    {isAdminLike ? (
                      <>
                        <Link to="/PostResultScreen" onClick={closeMenu}>
                          Post Results
                        </Link>
                        <Link to="/UserPayment" onClick={closeMenu}>
                          User Payments
                        </Link>
                        <Link to="/AdminTransactions" onClick={closeMenu}>
                          Transactions
                        </Link>
                        <Link to="/HighWinners" onClick={closeMenu}>
                          High Winners
                        </Link>
                        <Link to="/AllGames" onClick={closeMenu}>
                          All Games
                        </Link>
                        <Link to="/WinAbove" onClick={closeMenu}>
                          Users & SMS
                        </Link>
                      </>
                    ) : (
                      <>
                        <Link to="/Deposit" onClick={closeMenu}>
                          Deposit
                        </Link>
                        <Link to="/Withdrawal" onClick={closeMenu}>
                          Withdraw
                        </Link>
                        <Link to="/BetHistory" onClick={closeMenu}>
                          Bet History
                        </Link>
                        {/*<Link to="/Chat" onClick={closeMenu}>
                          Chat Admin
                        </Link>*/}
                      </>
                    )}
                    
                    <Link
                      to="#"
                      onClick={() => {
                        handleLogout();
                        closeMenu();
                      }}
                    >
                      Logout
                    </Link>

                  </div>
                </li>
              )}
            </ul>
            {!isLoggedIn && (
              <div className="login-form">
                <input
                  type="text"
                  placeholder="Phone Number/Email"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Link to="/password-reset" className="forgot-password-link" onClick={closeMenu}>
                  Forgot Password
                </Link>
                <button onClick={handleLogin} >Login</button>
              </div>
            )}
              {/* Links */}
        
            {!isLoggedIn && (
              <div className="register">
                <Link
                  to="/Register"
                  className="register-link"
                  onClick={closeMenu}
                >
                  SignUp
                </Link>
              </div>
            )}
            {isLoggedIn && !isPWA && (
              <UserProfile
                token={token}
                userData={userData}
                setUserData={setUserData}
                userBalance={userBalance}
                setUserBalance={setUserBalance}
                setWinBalance={setWinBalance}
              />
            )}
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/LotteryResults" element={<LotteryResults />} />
          <Route path="/services" element={<Services />} />
          <Route path="/forcasters" element={<Forcasters />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/MyAccount" element={<MyAccount />} />
          <Route path="/HubtelReceive" element={<HubtelReceive />} />
          <Route path="/Deposit" element={<Deposit />} />
          <Route path="/PaymentPage" element={<PaymentPage />} />
          <Route path="/Withdrawal" element={<Withdrawal />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/BetHistory" element={<BetHistory />} />
          <Route path="/MobileLogin" element={<MobileLogin />} />
          <Route path="/ArkeselLogin" element={<ArkeselLogin />} />
          <Route path="/verify" element={<VerifyScreen />} />
          <Route path="/password-reset" element={<PasswordResetStep1 />} />
          <Route path="/password-reset-sendexa" element={<SendexaPasswordReset />} />
          <Route path="/password-reset-sendexa-verify" element={<SendexaResetVerify />} />
          <Route path="/password-reset-sendchamp" element={<Navigate to="/password-reset-sendexa" replace />} />
          <Route path="/password-reset-sendchamp-verify" element={<Navigate to="/password-reset-sendexa-verify" replace />} />
          <Route path="/reset-password-verify" element={<ResetPasswordScreen />} />
          <Route path="/Faqs" element={<Faqs />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/UserReceipt" element={<UserReceipt />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/Chat" element={<Chat />} />
          
          {/* Redirect old /Home path to root */}
          <Route path="/Home" element={<Navigate to="/" replace />} />
          
          {/* Admin Routes - accessible to admin and superadmin */}
          {isAdminLike && (
            <>
              <Route path="/PostResultScreen" element={<PostResultScreen />} />
              <Route path="/UserPayment" element={<UserPayment />} />
              <Route path="/AdminTransactions" element={<AdminTransactions />} />
              <Route path="/HighWinners" element={<HighWinners />} />
              <Route path="/AllGames" element={<AllGames />} />
              <Route path="/WinAbove" element={<WinAbove />} />
            </>
          )}
        </Routes>
        
        {/*
        Daily referral commission banner
        {showReferralBanner && (
          <div className="referral-banner-overlay" onClick={dismissReferralBanner}>
            <div className="referral-banner-modal" onClick={(e) => e.stopPropagation()}>
              <div className="referral-banner-icon">🎁</div>
              <h2 className="referral-banner-title">Earn Free 5% Commission!</h2>
              <p className="referral-banner-body">
                Share your <strong>Booking Code</strong> with friends. Every time someone plays using your code, you earn a commission automatically credited straight to your balance!
              </p>
              <p className="referral-banner-hint">Find your code in the <strong>Ticket Receipt</strong> section.</p>
              <button className="referral-banner-btn" onClick={dismissReferralBanner}>Got it!</button>
            </div>
          </div>
        )}
        */}

        {/* Winners celebration banner */}
        {showWinnersBanner && (
          <div className="winners-banner-overlay" onClick={dismissWinnersBanner}>
            <div className="winners-banner-modal" onClick={(e) => e.stopPropagation()}>
              <div className="winners-banner-icon">🎉</div>
              <h2 className="winners-banner-title">Congratulations!</h2>
              <p className="winners-banner-body">You have won!</p>
              <div className="winners-banner-amount">GHS {totalWinnings.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
              <p className="winners-banner-hint">Check your <strong>Bet History</strong> for details.</p>
              <button className="winners-banner-btn" onClick={dismissWinnersBanner}>Awesome!</button>
            </div>
          </div>
        )}

        {/* PWA Install Prompt */}
        <InstallPWA />
        
        {/* FAB Buttons Row - persists on all routes */}
        <div className="fab-buttons-row">
          <div className="shortid-section">
            <ShortId />
          </div>
          <UserChat />
        </div>
      </div>
  );
};

export default App;
